module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success float-right",
    attrs: {
      "disabled": _vm.printing
    },
    on: {
      "click": _vm.printInvoices
    }
  }, [(_vm.printing) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner mr-5"
  }) : _c('i', {
    staticClass: "fa fa-print mr-5"
  }), _vm._v("\n      Print pakbonnen\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary mr-2 float-right",
    attrs: {
      "href": _vm.invoicesPdfUrl,
      "target": "_blank",
      "disabled": _vm.printing
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-5"
  }), _vm._v(" Download pakbonnen\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "si si-directions mr-5"
  }), _vm._v(" Bestellingen Picken\n  ")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v("  Bestellingen laden...\n  ")]) : _c('div', [(!_vm.singleBin) ? _c('div', {
    staticClass: "row gutters-tiny"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id,
      staticClass: "col-md-6 col-xl-2"
    }, [_c('div', {
      staticClass: "block text-center bin",
      on: {
        "click": function($event) {
          _vm.detailModalOrderId = order.id
        }
      }
    }, [_c('div', {
      staticClass: "bin__key"
    }, [_vm._v(_vm._s(order.bin.key))]), _vm._v(" "), _c('div', {
      staticClass: "block-content block-content-full text-right",
      style: ({
        'background-color': '#' + order.bin.color
      })
    }, [_c('div', {
      staticClass: "font-w600 text-white mb-5"
    }, [_vm._v("#" + _vm._s(order.number))]), _vm._v(" "), _c('div', {
      staticClass: "text-white-op text-one-line",
      attrs: {
        "title": order.billing_person
      }
    }, [_vm._v(_vm._s(order.billing_person))])])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block mt-20"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('strong', [_vm._v(_vm._s(this.currentProductIndex + 1))]), _vm._v(" van "), _c('strong', [_vm._v(_vm._s(_vm.products.length))]), _vm._v(" producten\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.previous
    }
  }, [_c('i', {
    staticClass: "si si-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "si si-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('swiper', {
    ref: "imageSwiper",
    staticStyle: {
      "height": "450px"
    }
  }, _vm._l((_vm.currentProduct.image_urls), function(image) {
    return _c('swiper-slide', {
      key: image
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": image
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('h1', {
    staticClass: "font-w700",
    on: {
      "click": function($event) {
        _vm.detailModalProductId = _vm.currentProduct.id
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentProduct.name) + "\n              "), _vm._m(0)]), _vm._v(" "), _c('h2', {
    staticClass: "mb-3"
  }, [(_vm.currentProduct.location) ? _c('mark', {
    staticClass: "pl-10 pr-10"
  }, [_vm._v(_vm._s(_vm.currentProduct.location))]) : _c('mark', {
    staticClass: "pl-10 pr-10 text-muted"
  }, [_vm._v("Locatie onbekend")]), _vm._v(" "), (_vm.currentProduct.shares_location) ? _c('span', {
    staticClass: "stock-warning text-danger"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" er liggen meedere producten op deze locatie!\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.currentProduct.overstock_location) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Overvoorraad: " + _vm._s(_vm.currentProduct.overstock_location))]) : _vm._e(), _vm._v(" "), (_vm.currentProduct.in_store) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Ligt in de winkel")]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "mt-50"
  }, [_vm._v("Aantal: " + _vm._s(_vm.totalQuantity))]), _vm._v(" "), (_vm.singleBin) ? _c('div', {
    staticClass: "block text-center",
    staticStyle: {
      "background-color": "#e82b18",
      "width": "100px"
    }
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "font-size-h1 text-white"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalQuantity) + "x")])])])]) : _c('div', {
    staticClass: "row gutters-tiny"
  }, _vm._l((_vm.currentProduct.quantities), function(quantity, orderNumber) {
    return _c('div', {
      key: orderNumber,
      staticClass: "col-6 col-md-4 col-xl-2"
    }, [_c('div', {
      staticClass: "block text-center",
      style: ({
        'background-color': '#' + _vm.findOrderByNumber(orderNumber).bin.color
      })
    }, [_c('div', {
      staticClass: "block-content bg-black-op-5"
    }, [_c('p', {
      staticClass: "font-w600 text-white-op"
    }, [_vm._v("#" + _vm._s(orderNumber))])]), _vm._v(" "), _c('div', {
      staticClass: "block-content"
    }, [_c('p', {
      staticClass: "font-size-h1 text-white"
    }, [_c('strong', [_vm._v(_vm._s(quantity) + "x")])])])])])
  }), 0)])])])]), _vm._v(" "), _c('nav', {
    staticClass: "clearfix push"
  }, [(!_vm.isFirstProduct) ? _c('button', {
    staticClass: "btn btn-alt-secondary min-width-100 float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.previous
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Vorige")]) : _vm._e(), _vm._v(" "), (_vm.isLastProduct) ? _c('button', {
    staticClass: "btn btn-success btn-noborder min-width-100 float-right btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finish
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw"
  }), _vm._v(" Afronden")]) : _c('button', {
    staticClass: "btn btn-alt-secondary min-width-100 float-right btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Volgende "), _c('i', {
    staticClass: "fa fa-arrow-right fa-fw"
  })])]), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailModalOrderId) ? _c('order-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "product-info-button"
  }, [_c('i', {
    staticClass: "si si-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce399e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/orders/PickOrdersPage.vue
// module id = 723
// module chunks = 1